import React from "react";

/** F-mark icon (matches Layout TopBar). */
export function FmarkIcon({ className = "h-8 w-auto", fill = "#09090B" }) {
  return (
    <svg aria-hidden="true" className={`${className} shrink-0`} viewBox="8 3 87 93" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M21.205,29.001h16.003h16.745h11.526c6.966,0,12.629-5.754,12.629-12.824c0-7.072-5.663-12.826-12.629-12.826H53.679H36.936h-15.73c-6.968,0-12.634,5.754-12.634,12.826C8.571,23.247,14.237,29.001,21.205,29.001z" />
      <path d="M82.22,36.832H21.205c-6.968,0-12.634,5.761-12.634,12.831c0,7.073,5.666,12.824,12.634,12.824H82.22c6.968,0,12.634-5.751,12.634-12.824C94.854,42.593,89.188,36.832,82.22,36.832z" />
      <path d="M53.682,70.511c0-0.055-0.003-0.11-0.003-0.162h-1.901H23.236h-2.031c-6.968,0-12.634,5.754-12.634,12.823C8.571,90.246,14.237,96,21.205,96h2.303h28.27h2.176c0-0.069,0-0.137,0-0.203c5.931-1.049,10.458-6.307,10.458-12.625C64.411,76.76,59.746,71.448,53.682,70.511z" />
    </svg>
  );
}

/**
 * Brand stripe (#EA580C) + optional wordmark.
 * stripe="top" | "none"
 */
export default function BrandMark({
  stripe = "top",
  size = "md",
  className = "",
  wordmarkClassName = "",
}) {
  const sizes = {
    sm: { icon: "h-6 w-auto", text: "text-lg" },
    md: { icon: "h-7 w-auto", text: "text-xl" },
    lg: { icon: "h-8 w-auto", text: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={className}>
      {stripe === "top" && (
        <div className="h-1 w-full bg-safety shrink-0" aria-hidden="true" data-testid="brand-stripe" />
      )}
      <div className={`flex items-center gap-2.5 ${stripe === "top" ? "pt-0" : ""}`}>
        <FmarkIcon className={s.icon} fill="#09090B" />
        <span className={`font-display font-black tracking-tight leading-none text-safety ${s.text} ${wordmarkClassName}`}>
          FACTLIFY
        </span>
      </div>
    </div>
  );
}
